'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.randomString = void 0;
var randomString = function (r) {
    r = r || 32;
    for (var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz', n = '', o = t.length, e = 0; e < r; e++)
        n += t.charAt(Math.floor(Math.random() * o));
    return n;
};
exports.randomString = randomString;